var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dd-profit-caption-wrap"},[_c('el-tooltip',{attrs:{"effect":"dark","placement":"top"}},[_c('div',{staticStyle:{"white-space":"pre-line"},attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.tipTxt))]),_c('i',{staticClass:"el-icon-question"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }